export default function dropletName() {
  return {
    _id: false,
    type: 'droplet.groupGrid',
    mediaQueries: [],
    pageCSS: '',
    sortKey: 'created',
    customCategories: [],
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    siteType: null,
    hideFilters: false,
    customList: false,
    paginate: 24,
    placeholder: 'Search...',
    sort: 'newest',
    match: 'all',
    filterText: 'Filters',
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/group-grid/droplet.schema.js